import styled, { css } from 'styled-components'

export const CatalogItemTagLabelStyled = styled.span<{
  $isWarning: boolean
}>`
  font-weight: ${(props) => props.theme.fontWeights.normal};

  ${(props) =>
    props.$isWarning
      ? css`
          font-size: ${props.theme.typography.pxToRem(14)};
          line-height: ${props.theme.typography.pxToRem(24)};
          color: ${props.theme.colors.badge.warning.content};
        `
      : css`
          font-size: ${props.theme.typography.pxToRem(12)};
          line-height: ${props.theme.typography.pxToRem(16)};
          color: ${props.theme.colors.text.secondary};
        `}
`
